import PropTypes from 'prop-types'

export const suggestionType = PropTypes.shape({
  type: PropTypes.oneOf(['organization_membership', 'organization_invitation', 'user_group', 'user_consolidation']),
  entity: PropTypes.shape({ id: PropTypes.number.isRequired }),
})
